import React from 'react';
import { Field } from '@h2/types';

interface SelectInputProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const SelectInput: React.FC<SelectInputProps> = ({ field, value, onChange, error }) => {
  return (
    <select
      id={field.id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
        error ? 'border-red-500' : ''
      }`}
    >
      <option value="">선택해주세요</option>
          {field.options?.map((option) => (
            <option key={String(option.value)} value={String(option.value)}>
              {option.label}
            </option>
          ))}
    </select>
  );
};
